import { motion } from "framer-motion";

export default function BrushDivider({ flip = false }) {
  return (
    <div className={`relative h-20 sm:h-28 overflow-hidden ${flip ? "rotate-180" : ""}`} aria-hidden>
      <motion.div
        initial={{ clipPath: "inset(0 100% 0 0)" }}
        whileInView={{ clipPath: "inset(0 0% 0 0)" }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 1.1, ease: [0.65, 0, 0.35, 1] }}
        className="absolute inset-0"
      >
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-full">
          <defs>
            <linearGradient id="brushgrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stopColor="#8A050C" />
              <stop offset="0.45" stopColor="#E50914" />
              <stop offset="1" stopColor="#5c040a" />
            </linearGradient>
          </defs>
          <path
            d="M-20,72 C120,38 260,88 420,58 C580,30 720,84 880,52 C1000,30 1120,60 1220,48 L1220,64 C1100,80 980,50 860,72 C700,100 560,50 400,78 C240,104 100,60 -20,90 Z"
            fill="url(#brushgrad)"
            opacity="0.85"
          />
          <circle cx="210" cy="34" r="4" fill="#E50914" opacity="0.7" />
          <circle cx="640" cy="98" r="3" fill="#E50914" opacity="0.6" />
          <circle cx="1050" cy="26" r="5" fill="#8A050C" opacity="0.8" />
          <circle cx="880" cy="20" r="2" fill="#CBD5E1" opacity="0.4" />
        </svg>
      </motion.div>
    </div>
  );
}
